import { createI18n } from "vue-i18n";
import nlJson from "@/localization/nl.json";
import { z } from "zod";
import { makeZodI18nMap } from "@/utils/make-zod-i18n-map";
import nlZod from "@/localization/nl/zod.json";

// TODO: Refactor WHOLE setup of i18n after migration to Vue3

interface Messages {
  [key: string]: any;
}

export const availableLanguages = ["nl"];
// regex to remove the path and the file extension
const keyRegex = /.*\/|\.[^/.]+$/g;

let preferredLang = localStorage.getItem(`${import.meta.env.VITE_NAME}_LANG`) || "nl";

preferredLang = preferredLang.substring(0, 2);
if (!availableLanguages.includes(preferredLang)) {
  preferredLang = "nl";
}
const messages: Messages = {};
messages[preferredLang] = getMessages(preferredLang);

export const i18n = createI18n({
  legacy: false,
  locale: preferredLang,
  fallbackLocale: preferredLang,
  messages: {
    ...messages,
    nl: {
      ...messages.nl,
      ...nlZod,
    },
  },
});

// @ts-ignore
export const t = i18n.global.t;

const loadedLanguages: string[] = [];

function setI18nLanguage(lang: string) {
  i18n.global.locale.value = lang;
  const el: HTMLElement | null = document.querySelector("html");
  if (el) {
    el.setAttribute("lang", lang);
  }
  localStorage.setItem(`${import.meta.env.VITE_NAME}_LANG`, lang);
  return lang;
}

function getMessages(lang: string) {
  let requireModule: any | null = null;
  if (lang === "nl") {
    requireModule = import.meta.glob("@/localization/nl/*.json", { eager: true });
  }

  const localMessages: Messages = [];
  localMessages[lang] = {};
  if (requireModule) {
    Object.keys(requireModule).forEach((fileName: string) => {
      const key = fileName.replace(keyRegex, "");
      localMessages[lang][key] = requireModule[fileName].default;
    });
  }

  return {
    ...nlJson,
    ...localMessages[lang],
  };
}

export function loadLanguageAsync(lang: string) {
  if (i18n.global.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  i18n.global.setLocaleMessage(lang, getMessages(lang));
  loadedLanguages.push(lang);
  return Promise.resolve(setI18nLanguage(lang));
}

z.setErrorMap(makeZodI18nMap(i18n));
